import React, { Component } from "react";
import {
  mode,
  profile,
  alert,
  float,
  toFixed,
  format_date,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DateRangePicker,
  Select,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  XLSX,
  saveAs,
  StatusTnx,
  linkRole
} from "../../components/CustomComponent.js";

import Dropdown from "react-bootstrap/Dropdown";
import { NumericFormat } from "react-number-format";
import "bootstrap/dist/css/bootstrap.min.css";
export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // MODAL
      modal_create: false,
      modal_update: false,
      modal_detail: false,

      // SEARCH
      filter_status: "",
      filter_start_date: "",
      filter_end_date: "",
      filter_data_search: params("ref_no") || "",
      filter_currency: "THB",
      filter_broker: "",

      // EXPORT
      export_date: "",

      // LIST
      data: [],
      count: 10,
      loaded: false,
      data_broker: [],
      data_customer: [],
      data_bank: [],

      // DETAIL
      customer_id: "",
      broker_id: "",

      uid: "",
      type: "",
      ref_no: "",
      status: "",
      amount: "",
      created_at: null,
      cost_gateway: "",
      fee: "",
      fee_rate: "",
      fee_type: "",
      vat: "",
      vat_rate: "",
      vat_type: "",
      is_vat: false,
      is_usdt: false,
      is_topup: false,
      is_hq: false,
      gateway: null,
      amount_net: "",
      open_balance: null,
      close_balance: null,
      currency: "",
      transaction_id: null,
      transfer_date: null,
      remark: null,
      broker: null,
      customer: null,

      bank_code: "",
      bank_account_number: "",
      bank_account_name_th: "",
      bank_account_name_en: "",

      select: -1,
    };
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([this.GetMaster(), this.Get(1)]);
  }
  // ตัวเลือกของ dropdown ทั้งหน้า ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
  // ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_bank;
    let [result_bank] = await Promise.all([
      GET("v1/admin/banks", { page_size: 100000, page: 0, data_search: "" }),
    ]);
    if (result_bank?.status) {
      const popularBankCodes = [
        "SCB",
        "KBANK",
        "KTB",
        "BBL",
        "BAY",
        "TTB",
        "CIMB",
      ];
      data_bank = result_bank.data
        .sort((a, b) => {
          const indexA = popularBankCodes.indexOf(a.code);
          const indexB = popularBankCodes.indexOf(b.code);

          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB; // ถ้าอยู่ทั้งคู่ใน popular → เรียงตามลำดับ
          } else if (indexA !== -1) {
            return -1; // a อยู่ใน popular → ให้มาก่อน
          } else if (indexB !== -1) {
            return 1; // b อยู่ใน popular → ให้มาก่อน
          } else {
            return a.name_en.localeCompare(b.name_en); // ไม่อยู่ใน popular → เรียงตามชื่อ
          }
        })
        .map((e) => ({
          value: e.code,
          label: e.name_en,
          front: (
            <img
              alt="bank"
              src={require(`../../assets/images/bank/${
                global.bank.find((b) => b.value === e.code)?.icon || "bank.png"
              }`)}
              width={18}
              height={18}
              style={{ marginRight: 6 }}
            />
          ),
        }));
    }
    this.setState({ data_bank });
  };
  Get = async (page) => {
    const {
      filter_data_search,
      filter_start_date,
      filter_end_date,
      filter_status,
      filter_currency,
      filter_broker,
    } = this.state;
    let data, count;
    loading(true);
    let [result] = await Promise.all([
      GET(`transactions/withdrawals/list`, {
        page_size: 10,
        page: page,
        data_search: filter_data_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        filter_status: filter_status,
        process_type: "withdrawals",
        currency: filter_currency,
        broker_id: filter_broker,
        is_hq: true,
      }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({
      data,
      count,
      select: -1,
      loaded: true,
    });
    loading(false);
  };

  GetCustomer = async () => {
    const { currency } = this.state;
    let data_customer;
    let [result_customer] = await Promise.all([
      GET("v1/admin/customers", {
        page_size: 100000,
        page: 0,
        data_search: "",
        currency: currency,
      }),
    ]);
    if (result_customer?.status) {
      data_customer = result_customer?.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
        bank_code: e.bank_code,
        bank_account_name_th: e.bank_account_name_th,
        bank_account_name_en: e.bank_account_name_en,
        bank_account_number: e.bank_account_number,
        broker: e.broker?.uid || "",
        currency: e.currency || "THB",
      }));
    }
    this.setState({
      data_customer,
    });
  };
  Create = async () => {
    const {
      broker_id,
      customer_id,
      ref_no,
      amount,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      currency,
      is_topup,
      is_hq,
    } = this.state;

    if (!broker_id.trim()) {
      alert("", "warning", "Warning", "Please select Broker");
      return;
    } else if (!ref_no.trim()) {
      alert("", "warning", "Warning", "Please input Ref No");
      return;
    } else if (!amount.trim()) {
      alert("", "warning", "Warning", "Please input Amount");
      return;
    }
    // if (is_hq && !customer_id) {
    //   alert("", "warning", "Warning", "Please select customer");
    //   return;
    // }

    let body = {
      broker_id,
      customer_id,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      ref_no,
      amount: Number(amount),
      currency: currency || "THB",
      is_topup: is_topup || false,
      is_hq: is_hq || false,
    };
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let result = await POST(`transactions/withdrawals/create`, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  Update = async (is_approved_auto) => {
    const { fee_type, fee_rate, is_vat, status, is_usdt } = this.state;
    if (!fee_type.trim()) {
      alert("", "warning", "Warning", "Please select Fee Rate Type");
      return;
    } else if (!fee_rate.trim()) {
      alert("", "warning", "Warning", "Please input Fee Rate");
      return;
    }
    if (["cancel", "success"].includes(status)) {
      Swal.fire({
        title: "Confirm",
        text: `Do you want to ${
          status === "cancel" ? "Reject" : "Approve"
        } the transaction?`,
        icon: "info",
        input: "textarea",
        inputPlaceholder: "Enter remark...",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        background: mode === "dark" ? "#000000" : "#fff", // Dark / Light background
        color: mode === "dark" ? "#fff" : "#000000", // Text color
        confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
        cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
      }).then(async (re) => {
        if (re.isConfirmed) {
          const remark = re.value;
          loading(true);
          let body = {
            fee_type,
            fee_rate: Number(fee_rate).toFixed(4),
            is_vat,
            status,
            is_usdt,
            remark,
            is_approved_auto: is_approved_auto || false,
          };
          let result = await PUT(
            `transactions/withdrawals/update/` + this.state.uid,
            body
          );
          if (result?.status) {
            // alert("#", "success");
            alert(
              "",
              "success",
              "Success",
              "Transaction updated successfully."
            );
            this.Get(1);
            this.setState({
              modal_create: false,
              modal_update: false,
              modal_detail: false,
            });
          } else {
            alert(
              "",
              "warning",
              "Warning",
              result?.message || "An error occurred. Please try again."
            );
          }
          loading(false);
        }
      });
    } else {
      if (
        await alert(
          "",
          "info",
          "Confirm",
          "Do you want to confirm the submission?",
          "Confirm",
          "Cancel"
        )
      ) {
        loading(true);
        let body = {
          fee_type,
          fee_rate: Number(fee_rate).toFixed(4),
          is_vat,
          status,
          is_usdt,
          is_approved_auto: is_approved_auto || false,
        };
        let result = await PUT(
          `transactions/withdrawals/update/` + this.state.uid,
          body
        );
        if (result?.status) {
          alert("#", "success");
        } else {
          alert(
            "",
            "warning",
            "Warning",
            result?.message || "An error occurred. Please try again."
          );
        }
        loading(false);
      }
    }
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "Delete Item",
        "Do you really want to delete this item?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let result = await DELETE(`transactions/withdrawals/delete/` + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  ReWithdrawal = async () => {
    const { uid } = this.state;
    Swal.fire({
      title: "Confirm",
      text: `Do you want to "withdrawal" again?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      background: mode === "dark" ? "#000000" : "#fff", // Dark / Light background
      color: mode === "dark" ? "#fff" : "#000000", // Text color
      confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
      cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
    }).then(async (re) => {
      if (re.isConfirmed) {
        loading(true);
        let body = { uid };
        let result = await POST(`transactions/withdrawals/re-order`, body);
        if (result?.status) {
          alert("#", "success");
        } else {
          alert(
            "",
            "warning",
            "Warning",
            result?.message || "An error occurred. Please try again."
          );
        }
        loading(false);
      }
    });
  };
  calDetail = async () => {
    const { fee_type, fee_rate, is_vat, amount, cost_gateway } = this.state;
    const _amount = Number(amount);
    const _fee =
      fee_type === "fixed"
        ? Number(fee_rate)
        : Number((_amount * (Number(fee_rate) / 100)).toFixed(4));
    const _vat = Number((_fee * 0.07).toFixed(4));
    const amountAfterFee = _amount + _fee;
    let amountNet = is_vat
      ? Number((amountAfterFee + _vat + Number(cost_gateway)).toFixed(4))
      : Number(amountAfterFee.toFixed(4));

    this.setState({
      fee: _fee.toFixed(4),
      amount_net: amountNet.toFixed(4),
      vat: is_vat ? _vat.toFixed(4) : "00.00",
    });
  };
  Callback = async () => {
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the Callback?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      const { uid } = this.state;
      let body = { uid };
      let result = await POST(`callback/re-callback`, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
   ExportCSV = async () => {
        const {
        filter_data_search,
        filter_start_date,
        filter_end_date,
        filter_status,
        filter_currency,
        filter_broker,
      } = this.state;
        loading(true);
        let result = await  GET(`transactions/withdrawals/list`, {
        page_size: 1000000,
        page: 0,
        data_search: filter_data_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        filter_status: filter_status,
        process_type: "withdrawals",
        currency: filter_currency,
        broker_id: filter_broker,
        is_hq: true,
      });
        if (result?.status) {
          const data_transaction = result.data;
    
          // EXPORT CSV
          const json_data = data_transaction.map((item) => ({
            time: format_date(item.created_at, "dd/mm/yy hh:mm", "en"),
            "Ref No": item.ref_no,
            Amount: toFixed(item.amount, 2),
            Fee: toFixed(item.fee, 2),
            VAT: toFixed(item.vat, 2),
            "Amount Net": toFixed(item.amount_net, 2),
            Process: "HQ",
            Status: item.status || "-",
            Remark: item.remark,
            currency: item.currency,
          }));
          // 1. Convert JSON to worksheet
          const worksheet_thb = XLSX.utils.json_to_sheet(
            json_data.filter((e) => e.currency === "THB"),
          );
          const worksheet_lak = XLSX.utils.json_to_sheet(
            json_data.filter((e) => e.currency === "LAK"),
          );
    
          // 2. Create a new workbook and append the worksheet
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet_thb, "THB");
          XLSX.utils.book_append_sheet(workbook, worksheet_lak, "LAK");
    
          // 3. Write the workbook to binary buffer
          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });
    
          // 4. Save to file
          const data = new Blob([excelBuffer], {
            type: "application/octet-stream",
          });
          saveAs(
            data,
            `settlementHQ-${format_date(
              filter_start_date,
              "dd/mm/yy",
              "en",
            )}-${format_date(filter_end_date, "dd/mm/yy", "en")}.xlsx`,
          );
        }
        loading(false);
      };
  render() {
    const {
      select,
      modal_create,
      modal_update,
      modal_detail,
      filter_status,
      filter_start_date,
      filter_end_date,
      filter_data_search,
      filter_currency,
      export_date,
      data,
      count,
      loaded,
      data_customer,
      data_bank,
      broker_id,
      customer_id,
      uid,
      type,
      ref_no,
      status,
      amount,
      created_at,
      fee,
      fee_rate,
      fee_type,
      vat,
      is_vat,
      is_hq,
      amount_net,
      currency,
      remark,
      broker,
      customer,
      cost_gateway,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      is_usdt,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Broker</div>
                <h2 className="ar-title mb-1">Settlement HQ Management</h2>
                <div className="ar-subtitle">
                  Manage and monitor Settlement HQ transactions
                </div>
              </div>
              <div className="ar-hero-actions">
                <button
                  className="ar-btn-ghost"
                  onClick={async () => {
                    this.ExportCSV();
                  }}
                >
                  <span className="icon me-2">{"\uf019"}</span>Export CSV
                </button>
                <button
                  className="ar-btn-gold settlements-hq.create"
                  onClick={async () => {
                    this.setState(
                      {
                        id: "",
                        currency: "THB",
                        broker_id:
                          profile?.user_type === "broker"
                            ? profile?.broker?.uid
                            : "",
                        customer_id: "",
                        ref_no: "",
                        amount: "",
                        bank_account_name_en: "",
                        bank_account_name_th: "",
                        bank_account_number: "",
                        bank_code: "",
                        is_topup: false,
                        is_hq: true,
                        modal_create: true,
                      },
                      () => {
                        this.GetCustomer();
                      }
                    );
                  }}
                >
                  <span className="icon me-2">{"\uf067"}</span>Create Settlement HQ
                </button>
              </div>
            </div>
            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label"><span className="icon me-2">{"\uf0b0"}</span>Filter</span>
                <span className="ar-toolbar-hint">Press Enter in the search box or click Search to apply</span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field ar-filter-field-search">
                  <span className="ar-filter-label">Search</span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Refno..."
                  onChange={(e) => {
                    this.setState({ filter_data_search: e.target.value });
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      this.Get(1);
                    }
                  }}
                  value={filter_data_search}
                />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Status</span>
                  <Select
                    className="form-control"
                    placeholder="Status"
                    options={[
                      { value: "", label: "Status" },
                      { value: "pending", label: "Pending" },
                      { value: "success", label: "Success" },
                      { value: "mismatch", label: "MisMatch" },
                      { value: "pending-refund", label: "Pending Refund" },
                      { value: "refund", label: "Refund" },
                      { value: "cancel", label: "Cancel" },
                    ]}
                    value={filter_status}
                    onChange={(v) => {
                      this.setState({ filter_status: v });
                    }}
                    default={false}
                  />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Date Range</span>
                  <DateRangePicker
                    className="form-control"
                    onChange={(e) => {
                      this.setState({
                        filter_start_date: e.start_date,
                        filter_end_date: e.end_date,
                      });
                    }}
                    value={{
                      start_date: filter_start_date,
                      end_date: filter_end_date,
                    }}
                    max={filter_end_date}
                  />
                </div>
                <div className="ar-toolbar-actions">
                <button
                  className="ar-btn-gold"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  <span className="icon me-2">{"\uf002"}</span>Search
                </button>
                <button
                  className="ar-btn-ghost"
                  onClick={() =>
                    this.setState(
                      {
                        filter_status: "",
                        filter_start_date: "",
                        filter_end_date: "",
                        filter_data_search: params("ref_no") || "",
                        filter_currency: "THB",
                        filter_broker: "",
                      },
                      () => this.Get(1)
                    )
                  }
                >
                  Reset
                </button>
                </div>
              </div>
              <div className="ar-filter-foot">
                  {global.currency?.map((item) => (
                    <button
                      className={`ar-pill ${
                        item.currency_code === filter_currency ? "active" : ""
                      }`}
                      onClick={() => {
                        this.setState({ filter_currency: item.currency_code });
                        setTimeout(() => {
                          this.Get(1);
                        }, 100);
                      }}
                    >
                      {item.image}
                      <span className="ms-1">{item.currency_code}</span>
                    </button>
                  ))}
              </div>
            </div>
          </div>
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{"\uf571"}</span>
                  Settlement HQ
                  <span className="pu-currency-tag">{filter_currency}</span>
                </div>
              </div>
            </div>
            <div className="table-responsive" style={{ minHeight: 300 }}>
              <table className="table table-hover text-nowrap ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    <td className="text-nowrap">Time</td>
                    <td className="text-nowrap">RefNo</td>
                    <td className="text-nowrap text-end">Amount</td>
                    <td className="text-nowrap text-center">Wallet Verify</td>
                    <td className="text-nowrap text-center">Pass Verify</td>
                    <td className="text-nowrap text-center">2FA Verify</td>
                    <td className="text-nowrap text-center">Expire</td>
                    <td className="text-nowrap text-center d-none d-md-table-cell">
                      Process
                    </td>
                    <td className="text-nowrap text-center wpx-100">Status</td>
                    <td className="settlements-hq.update text-nowrap text-center td-actions">
                      Actions
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {loaded && data?.length === 0 && (
                    <tr>
                      <td
                        colSpan={10}
                        className="text-center py-5"
                      >
                        <div className="ar-empty">No data</div>
                      </td>
                    </tr>
                  )}
                  {data?.map((item, index) => (
                    <tr
                      key={`array-${index}`}
                      onDoubleClick={() => {
                        this.setState({
                          select: select === index ? -1 : index,
                        });
                      }}
                    >
                      <td
                        data-label="Time"
                        className={
                          "text-nowrap" +
                          (index === select ? " bg-warning-light" : "")
                        }
                      >
                        {format_date(item.created_at, "dd/mm/yy hh:mm:ss", "en")}
                      </td>
                      <td
                        data-label="RefNo"
                        className={
                          "text-nowrap py-1" +
                          (index === select ? " bg-warning-light" : "")
                        }
                      >
                        <div>
                          <div style={{ height: 14 }}>{item.ref_no}</div>
                          {item.ref_no_refund && (
                            <small className="text-secondary">
                              refund no: {item.ref_no_refund}
                              <span
                                className="icon ms-1 text-primary pointer"
                                onClick={() => {
                                  window.location.href = `/${linkRole(profile?.user_type)}/deposits-withdrawals?type=withdrawals&ref_no=${item.ref_no_refund}`;
                                }}
                              >
                                {"\uf0c1"}
                              </span>
                            </small>
                          )}
                        </div>
                      </td>
                      <td
                        data-label="Amount"
                        className={
                          "text-nowrap text-end" +
                          (index === select ? " bg-warning-light" : "")
                        }
                      >
                        <div className="pu-amount">{toFixed(item.amount, 2)}</div>
                      </td>
                      <td
                        data-label="Wallet Verify"
                        className={
                          "text-nowrap text-center" +
                          (index === select ? " bg-warning-light" : "")
                        }
                      >
                        <span
                          className={
                            item.settlement?.is_wallet_address_verify
                              ? "text-success"
                              : "text-danger"
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "22px",
                            height: "22px",
                            borderRadius: "50%",
                            fontSize: "14px",
                            fontWeight: "bold",
                            backgroundColor: item.settlement?.is_wallet_address_verify
                              ? "#e9f9ef"
                              : "#fdecec",
                            border: `1px solid ${item.settlement?.is_wallet_address_verify ? "#198754" : "#dc3545"}`,
                          }}
                        >
                          {item.settlement?.is_wallet_address_verify ? "✓" : "✕"}
                        </span>
                      </td>
                      <td
                        data-label="Pass Verify"
                        className={
                          "text-nowrap text-center" +
                          (index === select ? " bg-warning-light" : "")
                        }
                      >
                        <span
                          className={
                            item.settlement?.is_password_verify
                              ? "text-success"
                              : "text-danger"
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "22px",
                            height: "22px",
                            borderRadius: "50%",
                            fontSize: "14px",
                            fontWeight: "bold",
                            backgroundColor: item.settlement?.is_password_verify
                              ? "#e9f9ef"
                              : "#fdecec",
                            border: `1px solid ${item.settlement?.is_password_verify ? "#198754" : "#dc3545"}`,
                          }}
                        >
                          {item.settlement?.is_password_verify ? "✓" : "✕"}
                        </span>
                      </td>
                      <td
                        data-label="2FA Verify"
                        className={
                          "text-nowrap text-center" +
                          (index === select ? " bg-warning-light" : "")
                        }
                      >
                        <span
                          className={
                            item.settlement?.is_2fa_verify
                              ? "text-success"
                              : "text-danger"
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "22px",
                            height: "22px",
                            borderRadius: "50%",
                            fontSize: "14px",
                            fontWeight: "bold",
                            backgroundColor: item.settlement?.is_2fa_verify
                              ? "#e9f9ef"
                              : "#fdecec",
                            border: `1px solid ${item.settlement?.is_2fa_verify ? "#198754" : "#dc3545"}`,
                          }}
                        >
                          {item.settlement?.is_2fa_verify ? "✓" : "✕"}
                        </span>
                      </td>
                      <td
                        data-label="Expire"
                        className={
                          "text-nowrap text-center" +
                          (index === select ? " bg-warning-light" : "")
                        }
                      >
                        {item.settlement?.expire_at
                          ? format_date(
                              item.settlement.expire_at,
                              "dd/mm/yy hh:mm",
                              "en"
                            )
                          : ""}
                      </td>
                      <td
                        data-label="Process"
                        className={
                          "text-nowrap text-center py-1 d-none d-md-table-cell" +
                          (index === select ? " bg-warning-light" : "")
                        }
                      >
                        {!item.is_topup && !item.is_hq && (
                          <div className="d-flex align-items-center justify-content-center">
                            {item.process_type === "manual"
                              ? Status("manual", "info")
                              : item.process_type === "auto"
                              ? Status("auto", "success")
                              : Status("-", "warning")}
                          </div>
                        )}
                        {item.is_topup && (
                          <div className="d-flex align-items-center justify-content-center mt-1">
                            {Status("topup", "primary")}
                          </div>
                        )}
                        {item.is_hq && (
                          <div className="d-flex align-items-center justify-content-center mt-1">
                            {Status("HQ", "purple")}
                          </div>
                        )}
                      </td>
                      <td
                        data-label="Status"
                        className={
                          "text-nowrap text-center py-1" +
                          (index === select ? " bg-warning-light" : "")
                        }
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          {StatusTnx(item.status)}
                        </div>
                      </td>
                      <td
                        data-label="Actions"
                        className={
                          `settlements-hq.update text-center td-actions` +
                          (index === select ? " bg-warning-light" : "")
                        }
                      >
                        <Dropdown align="end">
                          <Dropdown.Toggle
                            className="pu-action-toggle"
                            id={`settlements-hq-actions-${index}`}
                          >
                            Action
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                            <Dropdown.Item
                              className="pu-action-item"
                              onClick={() => {
                                this.setState({ ...item, modal_detail: true });
                              }}
                            >
                              <div className="icon">
                                {"\uf06e"}
                              </div>{" "}
                              Detail
                            </Dropdown.Item>
                            {["success", "mismatch", "cancel", "refund"].includes(
                              item.status
                            ) && (
                              <Dropdown.Item
                                className="settlements-hq.update pu-action-item"
                                onClick={() => {
                                  this.setState(
                                    {
                                      ...item,
                                      broker_id: item?.broker?.uid || "",
                                    },
                                    () => {
                                      this.Callback();
                                    }
                                  );
                                }}
                              >
                                <div className="icon">
                                  {"\uf1d8"}
                                </div>{" "}
                                Resend Callback
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_create}
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={() => this.setState({ modal_create: false })}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">New transaction</div>
              <h5 className="fw-bold mb-0">Create Transaction Settlement HQ</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Currency{required}</div>
              <Select
                className="form-control"
                placeholder="Currency..."
                options={global.currency?.map((e) => ({
                  label: e.currency_code,
                  value: e.currency_code,
                  front: e.image,
                }))}
                onChange={(e, i) => {
                  this.setState(
                    {
                      currency: e,
                      broker_id: e ? broker_id : "",
                      customer_id: e ? customer_id : "",
                      bank_code: e ? bank_code : "",
                      bank_account_number: e ? bank_account_number : "",
                      bank_account_name_th: e ? bank_account_name_th : "",
                      bank_account_name_en: e ? bank_account_name_en : "",
                    },
                    () => {
                      this.GetCustomer();
                    }
                  );
                }}
                value={currency}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Customer</div>
              <Select
                className="form-control"
                placeholder="Customer..."
                options={data_customer
                  ?.filter((e) => e.broker === broker_id)
                  .filter((e) => e.currency === currency)}
                onChange={(e, i) => {
                  this.setState({
                    customer_id: e,
                    bank_code: e ? i.bank_code : "",
                    bank_account_name_th: e ? i.bank_account_name_th : "",
                    bank_account_name_en: e ? i.bank_account_name_en : "",
                    bank_account_number: e ? i.bank_account_number : "",
                  });
                }}
                value={customer_id}
                disabled={!broker_id}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Ref no{required}</div>
              <input
                type="text"
                className="form-control pr-input"
                placeholder="Ref no..."
                maxLength={100}
                onChange={(e) => {
                  this.setState({ ref_no: e.target.value });
                }}
                value={ref_no}
              />
              <button
                className="btn btn-dark ms-2 px-3 text-nowrap"
                onClick={() => {
                  this.setState({ ref_no: new Date().getTime().toString() });
                }}
              >
                Generate
              </button>
            </div>
            <div className="d-flex mb-3 position-relative">
              <div className="wpx-150 mt-2 pr-label">Amount{required}</div>
              <NumericFormat
                thousandSeparator=","
                decimalScale={2}
                type="text"
                className="form-control pr-input pe-5"
                placeholder="Amount..."
                value={amount}
                onValueChange={(values) => {
                  this.setState({ amount: values.value });
                }}
              />
              <span
                className="text-secondary position-absolute"
                style={{ right: 12, top: 6 }}
              >
                {currency || "THB"}
              </span>
            </div>
            {broker_id && (
              <div>
                <div className="pu-section-title mt-4">
                  <span className="icon">{"\uf19c"}</span>Bank Information
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-150 mt-2 pr-label">Bank Name{required}</div>
                  <Select
                    className="form-control"
                    placeholder="Bank Name..."
                    options={data_bank}
                    onChange={(e) => {
                      this.setState({ bank_code: e });
                    }}
                    value={bank_code}
                    disabled={customer_id}
                  ></Select>
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-150 mt-2 pr-label">Account Number{required}</div>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Account Number..."
                    maxLength={20}
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ bank_account_number: e.target.value });
                    }}
                    value={bank_account_number}
                    disabled={customer_id}
                  />
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-150 mt-2 pr-label">Account NameTH{required}</div>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Account NameTH..."
                    onChange={(e) => {
                      this.setState({ bank_account_name_th: e.target.value });
                    }}
                    value={bank_account_name_th}
                    disabled={customer_id}
                  />
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-150 mt-2 pr-label">Account NameEN{required}</div>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Account NameEN..."
                    onChange={(e) => {
                      this.setState({ bank_account_name_en: e.target.value });
                    }}
                    value={bank_account_name_en}
                    disabled={customer_id}
                  />
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill"
              onClick={() => {
                this.Create();
              }}
            >
              submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({ modal_create: false });
              }}
            >
              cancel
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={modal_update}
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={() => this.setState({ modal_update: false })}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Edit transaction</div>
              <h5 className="fw-bold mb-0">Create Transaction Settlement HQ</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">Status</div>
              <div className="w-100 mt-2">{StatusTnx(status)}</div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">Ref No.</div>
              <div className="w-100 mt-2">{ref_no}</div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">Time</div>
              <div className="w-100 mt-2">
                {format_date(created_at, "dd/mm/yyyy", "en")}
              </div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">Type</div>
              <div className="w-100 mt-2">{type}</div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">Customer</div>
              <div className="w-100 mt-2">{customer?.name_en || "-"}</div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">Broker</div>
              <div className="w-100 mt-2">{broker?.name_en || "-"}</div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">Fee Rate Type</div>
              <Select
                className="form-control"
                placeholder="Fee Rate Type..."
                options={[
                  { value: "percentage", label: "Percentage" },
                  { value: "fixed", label: "Fixed" },
                ]}
                onChange={(e) => {
                  this.setState({ fee_type: e });
                  setTimeout(() => {
                    this.calDetail();
                  }, 10);
                }}
                value={fee_type}
                disabled={is_usdt}
              ></Select>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">Fee Rate</div>
              <div className="position-relative w-100">
                <input
                  type="text"
                  className="form-control pr-input"
                  placeholder="Fee Rate..."
                  onChange={(e) => {
                    if (!float(e.target.value, 4)) return;
                    this.setState({ fee_rate: e.target.value });
                    setTimeout(() => {
                      this.calDetail();
                    }, 10);
                  }}
                  value={!is_usdt ? fee_rate : "0.00"}
                  disabled={is_usdt}
                />
                <span
                  className="position-absolute text-secondary"
                  style={{ right: 12, top: 6 }}
                >
                  {fee_type === "percentage" ? "%" : currency || "THB"}
                </span>
              </div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">Amount</div>
              <div className="w-100 mt-2">
                {toFixed(amount, 2)} {currency || "THB"}
              </div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">Fee</div>
              <div className="w-100 mt-2">
                {!is_usdt ? toFixed(fee, 2) : "0.00"} {currency || "THB"}
              </div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">VAT Type</div>
              <div className="w-100 mt-2 d-flex align-items-center">
                <Switch
                  className="me-3"
                  onChange={(e) => {
                    this.setState({ is_vat: e });
                    setTimeout(() => {
                      this.calDetail();
                    }, 10);
                  }}
                  checked={is_vat && !is_usdt}
                  disabled={is_usdt}
                />{" "}
                {is_vat && !is_usdt ? "VAT" : "NO VAT"}
              </div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">VAT</div>
              <div className="w-100 mt-2">
                {!is_usdt ? toFixed(vat, 2) : "0.00"} {currency || "THB"}
              </div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">Amount Net</div>
              <div className="w-100 mt-2">
                {!is_usdt ? toFixed(amount_net, 2) : toFixed(amount, 2)}{" "}
                {currency || "THB"}
              </div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">Remark</div>
              <div className="w-100 mt-2">{remark}</div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">Accountant Remark</div>
              <div className="w-100 mt-2">{""}</div>
            </div>
            <div className="d-flex mb-1">
              <div className="wpx-140 mt-2 pr-label">USDT</div>
              <div className="w-100 mt-2 d-flex align-items-center">
                <Switch
                  className="me-3"
                  onChange={(e) => {
                    this.setState({ is_usdt: e });
                    setTimeout(() => {
                      this.calDetail();
                    }, 10);
                  }}
                  checked={is_usdt}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill settlements-hq.update"
              onClick={() => {
                this.Update();
              }}
            >
              submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({ modal_update: false });
              }}
            >
              cancel
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={modal_detail}
          size="lg"
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={() => this.setState({ modal_detail: false })}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Transaction detail</div>
              <h5 className="fw-bold mb-0">Create Transaction Settlement HQ</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section mb-0">
            <div className="pu-kv">
              <span className="pu-kv-label">Status</span>
              <span className="pu-kv-value">{StatusTnx(status)}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Ref No.</span>
              <span className="pu-kv-value">{ref_no}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Time</span>
              <span className="pu-kv-value">{format_date(created_at, "dd/mm/yyyy", "en")}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Type</span>
              <span className="pu-kv-value">{type}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Customer</span>
              <span className="pu-kv-value">{customer?.name_en || "-"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Broker</span>
              <span className="pu-kv-value">{broker?.name_en || "-"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Fee Rate Type</span>
              <span className="pu-kv-value">{fee_type}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Fee Rate</span>
              <span className="pu-kv-value">{toFixed(fee_rate, 2)}{" "}
                {fee_type === "percentage" ? "%" : currency || "THB"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Amount</span>
              <span className="pu-kv-value">{toFixed(amount, 2)} {currency || "THB"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Fee Gateway</span>
              <span className="pu-kv-value">{toFixed(cost_gateway, 2)} {currency || "THB"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Fee</span>
              <span className="pu-kv-value">{toFixed(fee, 2)} {currency || "THB"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">VAT Type</span>
              <span className="pu-kv-value">{is_vat ? "VAT" : "NO VAT"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">VAT</span>
              <span className="pu-kv-value">{toFixed(vat, 2)} {currency || "THB"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Amount Net</span>
              <span className="pu-kv-value">{toFixed(amount_net, 2)} {currency || "THB"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Remark</span>
              <span className="pu-kv-value">{remark}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Accountant Remark</span>
              <span className="pu-kv-value">{""}</span>
            </div>
            {profile?.user_type === "super_user" && (
              <div className="pu-kv">
              <span className="pu-kv-label">Url Payment</span>
              <span className="pu-kv-value"><a
                    href={`${window.location.origin}/qr-source-link?i=${uid}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {window.location.origin}/qr-source-link?i={uid}
                  </a>
                </span>
              </div>
            )}
            </div>
            <div className="pu-section mb-0 mt-3">
              <div className="pu-section-title">
                <span className="icon">{"\uf19c"}</span>Bank Account
              </div>

            <div className="pu-kv">
              <span className="pu-kv-label">Bank Name</span>
              <span className="pu-kv-value">
                <img
                  alt="bank"
                  src={require(`../../assets/images/bank/${
                    global.bank.find((b) => b.value === bank_code)?.icon ||
                    "bank.png"
                  }`)}
                  width={18}
                  height={18}
                  style={{ marginRight: 6 }}
                />
                {bank_code}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Account Number</span>
              <span className="pu-kv-value">{bank_account_number}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Account Name EN</span>
              <span className="pu-kv-value">{bank_account_name_en}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Account Name TH</span>
              <span className="pu-kv-value">{bank_account_name_th}</span>
            </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-outline-dark px-5 rounded-pill"
              onClick={() => {
                this.setState({ modal_detail: false });
              }}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
